import { useState } from "react";
import {
    Input,
    InputGroup,
    InputLeftElement,
    InputRightElement,
    IconButton,
    FormControl,
    FormErrorMessage,
} from "@chakra-ui/react";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";

import { InputProps } from "./interface/input-props";

export const CustomInputComponent = ({
    type = "text",
    placeholder,
    value,
    onChange,
    leftIcon,
    errorMessage = "",
}: InputProps) => {
    const [show, setShow] = useState(false);
    const [inputType, setInputType] = useState(type);

    const isPassword = type === "password";

    const handleChangeInputType = () => {
        setInputType(!show ? "text" : "password");
        setShow(!show);
    };

    const LeftIconComponent = leftIcon;

    return (
        <FormControl
            isInvalid={errorMessage !== ""}
            style={{ width: "fit-content" }}
        >
            <InputGroup>
                {LeftIconComponent && (
                    <InputLeftElement pointerEvents="none">
                        <LeftIconComponent
                            color="gray.500"
                            height={5}
                            width={5}
                        />
                    </InputLeftElement>
                )}

                <Input
                    type={inputType}
                    placeholder={placeholder}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                />

                {isPassword && (
                    <InputRightElement>
                        <IconButton
                            variant="ghost"
                            aria-label="Mostrar"
                            icon={
                                !show ? (
                                    <ViewOffIcon
                                        height={5}
                                        width={5}
                                        color="gray.500"
                                    />
                                ) : (
                                    <ViewIcon
                                        height={5}
                                        width={5}
                                        color="gray.500"
                                    />
                                )
                            }
                            onClick={handleChangeInputType}
                        />
                    </InputRightElement>
                )}
            </InputGroup>

            {errorMessage !== "" && (
                <FormErrorMessage>{errorMessage}</FormErrorMessage>
            )}
        </FormControl>
    );
};
